var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.102 1.242 9.879 4.88l3.91.574a.892.892 0 0 1 .711.602c.11.3.027.656-.219.875l-2.844 2.816.684 3.992a.859.859 0 0 1-.355.848c-.274.219-.63.219-.93.082l-3.5-1.887-3.527 1.887a.839.839 0 0 1-.903-.082.859.859 0 0 1-.355-.848l.656-3.992L.363 6.93c-.218-.22-.3-.575-.218-.875a.892.892 0 0 1 .71-.602l3.938-.574 1.75-3.637A.852.852 0 0 1 7.336.75c.328 0 .629.191.766.492Z"
  })));
};
export default SvgStarFilled;